import React, { useCallback } from 'react';
import { Form } from '@src/components/ui/react-hook-form/form/form';
import PropTypes from 'prop-types';
import { QuantityField } from './quantity-field';
import { Actions } from './actions';
import { CheckboxGroup } from '@src/components/ui/react-hook-form/checkbox/checkbox-group';
import { Divider } from '@mui/material';
import { Subtotal } from './subtotal';
import { DateTimeField } from './date-time-field';
import { AddOnLabel } from '@src/views/common/add-ons/add-ons';

const DEFAULT_VALUES = {
    quantity: 1
};

export const ContactSeller = ({ user, itemDetails, ...props }) => {
    const getAddOnLabel = useCallback(addOn => <AddOnLabel addOn={addOn} />, []);

    return (
        <Form className='contact-section ' defaultValues={DEFAULT_VALUES}>
            <div className='tw-flex tw-flex-col tw-gap-[20px] tw-p-[16px] tw-bg-primary-200'>
                <div className='tw-flex tw-flex-col tw-gap-[12px]'>
                    <DateTimeField {...(itemDetails?.seller || {})} />
                    <div className='tw-flex tw-flex-col tw-gap-[4px]'>
                        <QuantityField price={itemDetails.price} priceUnit={itemDetails.priceUnit} />
                    </div>
                    {itemDetails.addOns.length > 0 && (
                        <div>
                            <span className='tw-font-medium'>Add-ons</span>
                            <div className='tw-flex tw-flex-col tw-gap-[4px]'>
                                <CheckboxGroup
                                    name='addOns'
                                    options={itemDetails.addOns || []}
                                    getLabel={getAddOnLabel}
                                    getValue={addOn => addOn}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <Divider className='tw-w-full tw-mx-auto' />
                <div className='subtotal tw-flex tw-flex-col tw-justify-center tw-items-end'>
                    <Subtotal price={itemDetails.price} />
                </div>
                <div className='tw-flex tw-flex-col tw-gap-2'>
                    <span className='tw-text-[14px] tw-mt-4'>
                        Same‑day tasks cannot be booked through the calendar. If you need help today, use the
                        chat/request quote option to connect with the Tasker directly.
                    </span>
                    <Actions
                        itemDetails={itemDetails}
                        user={user}
                        getUserChannels={props.getUserChannels}
                        getChatDetails={props.getChatDetails}
                        createChatChannel={props.createChatChannel}
                    />
                </div>
            </div>
        </Form>
    );
};

ContactSeller.propTypes = {
    user: PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        Guest: PropTypes.bool
    }).isRequired,
    itemDetails: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        seller: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
        }).isRequired,
        price: PropTypes.number,
        priceUnit: PropTypes.string,
        addOns: PropTypes.array
    }).isRequired,
    getUserChannels: PropTypes.func.isRequired,
    getChatDetails: PropTypes.func.isRequired,
    createChatChannel: PropTypes.func.isRequired
};
